import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_STOCK_MARKETS_SUCCESS = 'GET_STOCK_MARKETS_SUCCESS';
export const GET_STOCK_MARKETS_FAILURE = 'GET_STOCK_MARKETS_FAILURE';

function receive(stockMarkets) {
  return {
    type: GET_STOCK_MARKETS_SUCCESS,
    stockMarkets
  };
}

function reject() {
  return {
    type: GET_STOCK_MARKETS_FAILURE
  };
}

export function getStockMarkets() {
  return (dispatch) => {
    const promise = () => ApiService
      .getStockMarkets()
      .then((response) => {
        dispatch(receive(response.data));
      }).catch((error) => {
        if (!error.response) {
          ApiService.addQueuedPromise(promise, error);
        } else if (error.retries && error.retries > 1) {
          dispatch(handleException(error, reject, false));
        }
      });
    return promise();
  };
}
